<template>
  <div class="header">
    <van-nav-bar
        title="专题 - 四川手机报"
        left-text=" "
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="logocenter">
      <div class="logo" style="line-height: 0">
        <van-image :src="back"></van-image>
      </div>
      <div class="special-desc">
          <i class="iconfont icon-yinyong"></i>
          <div class="c">{{desc}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['back','desc','title'],
  data() {
    return {}
  },
  methods: {
    onClickLeft() {
      this.$router.push({name: 'index'})
    }
  },
};
</script>

<style scoped lang="less">
.header{
  background: #fff;
}
.special-desc{
  padding:20px 40px;
  font-size:14px;
  .iconfont{
    font-size:26px;
    color:#999;
  }
  .c{
    line-height: 25px;
    margin-top:10px;
    color:#999;
  }
}
</style>
